import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=9cc112b6&scoped=true&"
import script from "./PageContent.vue?vue&type=script&lang=ts&"
export * from "./PageContent.vue?vue&type=script&lang=ts&"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=9cc112b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc112b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9cc112b6', component.options)
    } else {
      api.reload('9cc112b6', component.options)
    }
    module.hot.accept("./PageContent.vue?vue&type=template&id=9cc112b6&scoped=true&", function () {
      api.rerender('9cc112b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/PageContent.vue"
export default component.exports